import { Platform } from '@angular/cdk/platform';
import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs';

import { MobileAppDetectorService } from '../mobile-app-detector/mobile-app-detector.service';

@Injectable({
  providedIn: 'root',
})
export class MobileAppViewService {
  readonly #mobileAppDetectorService = inject(MobileAppDetectorService);
  readonly #platform = inject(Platform);

  // @ts-ignore: Hook to call back to the C#/Xamarin code on the mobile platform
  readonly androidActionExecutor = (message: string) => jsBridge.invokeAction(message);
  // @ts-ignore: Hook to call back to the C#/Xamarin code on the mobile platform
  readonly iosActionExecutor = (message: string) => window.webkit.messageHandlers.invokeAction.postMessage(message);

  readonly isMobileDevice = (): boolean => this.#platform.IOS || this.#platform.ANDROID;

  readonly isMobileApplication$ = toObservable(this.#mobileAppDetectorService.isMobileApp);
  readonly isMobileApplication = () => this.isMobileApplication$;

  invokeCSharpAction(message: string): void {
    this.isMobileApplication$
      .pipe(
        take(1),
        filter((isMobileApplication) => isMobileApplication),
      )
      .subscribe(() => {
        if (this.#platform.ANDROID) {
          this.androidActionExecutor(message);
        }

        if (this.#platform.IOS) {
          this.iosActionExecutor(message);
        }
      });
  }

  constructor() {}
}
